"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var authentication_1 = require("./authentication");
Object.defineProperty(exports, "authentication", { enumerable: true, get: function () { return authentication_1.authentication; } });
var populate_header_1 = require("./populate-header");
Object.defineProperty(exports, "populateHeader", { enumerable: true, get: function () { return populate_header_1.populateHeader; } });
//# sourceMappingURL=index.js.map